import React from 'react';
import { Text, NumberValue } from '../../typography';
import styled from 'styled-components/macro';
import { FlexWrapper, SPACINGS, valueToPercent } from '../../utils';

const Container = styled.div`
  display: grid;
  grid-template-columns: min-content 1fr min-content;
  /* grid-template-rows: ${SPACINGS[5]}; */
`;

type BarProps = {
  color: string;
  value: number;
  backgroundColor?: string;
};
const Bar = styled.div<BarProps>`
  background-color: ${(p) => p.backgroundColor ?? p.theme.colors.secondary95w};
  margin: 5px ${SPACINGS[4]} 0;
  height: 10px;
  border-radius: 2px;
  position: relative;
  overflow: hidden;
  flex: 1;

  :before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    background-color: ${(p) => p.color};
    transition: width 0.2s;
    width: ${(p) => valueToPercent(p.value, 0, 1)}%;
    height: 100%;
  }
`;

type HorizontalBarsChartProps = {
  data: {
    label: string;
    value: number;
    color: string;
    backgroundColor?: string;
  }[];
  digits?: number;
  style?: React.CSSProperties;
  labelStyle?: React.CSSProperties;
  valueStyle?: React.CSSProperties;
  styleType?: 'single-line' | 'multi-line';
  testid?: string;
};
function HorizontalBarsChart(props: HorizontalBarsChartProps) {
  const {
    data,
    digits,
    styleType = 'single-line',
    style,
    labelStyle = {},
    valueStyle = {},
    testid,
  } = props;

  if (styleType === 'multi-line')
    return (
      <FlexWrapper data-testid={testid} style={style} direction="column">
        {data.map((item, i) => (
          <FlexWrapper
            direction="column"
            align="flex-start"
            key={i}
            style={{ marginBottom: SPACINGS[1] }}
          >
            <Text
              style={{ whiteSpace: 'nowrap', ...labelStyle }}
              size="sm"
              type="label"
              margin="none"
            >
              {item.label}
            </Text>
            <FlexWrapper>
              <Bar
                style={{ margin: 0 }}
                color={item.color}
                backgroundColor={item.backgroundColor}
                value={item.value}
              />
              <FlexWrapper
                justify="flex-end"
                style={{ minWidth: 60, width: 'auto' }}
              >
                <NumberValue
                  size="sm"
                  type="percentage"
                  value={item.value}
                  digits={digits}
                  style={valueStyle}
                />
              </FlexWrapper>
            </FlexWrapper>
          </FlexWrapper>
        ))}
      </FlexWrapper>
    );

  return (
    <Container data-testid={testid} style={style}>
      {data.map((item, i) => (
        <React.Fragment key={i}>
          <Text
            style={{ whiteSpace: 'nowrap', ...labelStyle }}
            size="sm"
            type="label"
          >
            {item.label}
          </Text>
          <Bar
            color={item.color}
            backgroundColor={item.backgroundColor}
            value={item.value}
          />
          <NumberValue
            size="sm"
            type="percentage"
            value={item.value}
            digits={digits}
            style={valueStyle}
          />
        </React.Fragment>
      ))}
    </Container>
  );
}

export default HorizontalBarsChart;
